/* eslint-disable react/no-unused-prop-types */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useRef } from 'react';
import { Editor as TinymceEditor } from '@tinymce/tinymce-react';
import { FormControl } from '@mui/material';
import ElementUtils from '../../utils';
import '../editor.css';
import { EditorProps } from '../types';

function EditorDistractionFree(props: EditorProps) {
  const {
    onChange,
    value,
    error,
    disabled,
    placeholder,
  } = props;
  const editorRef = useRef<TinymceEditor>(null);

  return (
    <FormControl className="w-full h-full" component="fieldset" variant="standard">
      <TinymceEditor
        tinymceScriptSrc={`${process.env.PUBLIC_URL}/tinymce/tinymce.min.js`}
        ref={editorRef}
        disabled={disabled}
        value={value}
        onEditorChange={(e) => {
          if (onChange) {
            onChange(e, editorRef.current?.editor?.isDirty());
          }
        }}
        init={{
          placeholder: placeholder || 'Type here...',
          object_resizing: false,
          menubar: false,
          convert_urls: false,
          toolbar: false,
          inline: true,
          visual: false,
          plugins: ['quickbars', 'link'],
          quickbars_insert_toolbar: 'undo redo',
          quickbars_selection_toolbar: 'undo redo bold italic underline blocks forecolor blockquote quicklink alignleft aligncenter alignright alignjustify',
          content_css: 'editorCss',
        }}
      />
      {error && (
        <div className="absolute -bottom-5 text-error text-xs">
          {ElementUtils.renderError(error)}
        </div>
      )}
    </FormControl>
  );
}

EditorDistractionFree.defaultProps = {
  onChange: () => { },
  defaultValue: undefined,
  placeholder: '',
};

EditorDistractionFree.propTypes = {};

export default EditorDistractionFree;
